import * as React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';

import { MAX_LENGTH_256 } from '../../../lib/constants';
import { CustomFormFieldComponentProps } from '../../../lib/types/types';
import { InputTextAreaComponent } from '../../InputFields/InputTextArea/InputTextAreaComponent';


const ProjectDescription = ({ value, isErrored, onChange, placeholder = '', rows, cols }: CustomFormFieldComponentProps) => {

    return (
        <div className="sid-field sid-project-description">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-project-description">
                <div className='sid-field__label sid-field__label--required sid-l-space-btm-sm'>
                    <FormattedHTMLMessage
                        id="step.personalInfo.projectDescriptionLabel"
                        defaultMessage="Project Description"
                    />
                </div>
            </label>

            <InputTextAreaComponent
                className={
                    `sid-text-input sid-text-input--required
                        sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                }
                id="project-description"
                name="project-description"
                refId="projectDescription"
                rows={rows}
                cols={cols}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                maxLength={MAX_LENGTH_256}
                isErrored={isErrored}
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidProjectDescription"
                            defaultMessage="Invalid project description"
                        />
                    </div>
                ) : null
            }

        </div>
    );
};

export const  ProjectDescriptionComponent = injectIntl(ProjectDescription);

